import { ConversationChunkPage } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetConversationChunksRequest = {
	id: number;
	beforeChar?: number;
	pageChars?: number;
};

export const getConversationChunks = createGetEndpoint<GetConversationChunksRequest, ConversationChunkPage>(
	({ id, beforeChar, pageChars = 8000 }) => `/api/v3/agent/conversations/${id}/chunks?${getQueryString({
		beforeChar,
		pageChars
	})}`
);
